<div class="progress-panel">
  <div class="ticket-progress-card">
    <div class="ticket-progress-header">
      <div class="ticket-progress-title">
        <h3>处理进度</h3>
        <p>
          · 更新时间：
          <app-datetime [text]="logs[0]?.created_time"></app-datetime>
        </p>
      </div>
      <div
        class="ticket-progress-badge"
        *ngIf="progress"
        [ngClass]="{
          'is-waiting': progress === 'Supplemented',
          'is-finished':
            progress === 'Completed' || progress === 'ProcessCompleted',
        }"
      >
        <ng-container *ngIf="progress === 'Supplemented'">已补充</ng-container>
        <ng-container *ngIf="progress === 'Processing'">处理中</ng-container>
        <ng-container
          *ngIf="progress === 'Completed' || progress === 'ProcessCompleted'"
        >
          已完成
        </ng-container>
      </div>
    </div>

    <div
      class="ticket-progress-flow three-step"
      [ngClass]="progress === 'Supplemented' ? 'three-step' : 'two-step'"
    >
      <div
        class="ticket-progress-step"
        [ngClass]="progress === 'Processing' ? 'active' : 'done'"
      >
        <div class="ticket-step-icon">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle
              class="ticket-spin"
              cx="12"
              cy="12"
              r="7"
              stroke="currentColor"
              stroke-width="2.6"
              stroke-linecap="round"
              stroke-dasharray="28 18"
            ></circle>
          </svg>
        </div>
        <div class="ticket-step-name">处理中</div>
      </div>
      <div class="ticket-progress-segment">
        <div
          class="ticket-progress-fill"
          [ngClass]="progress === 'Processing' ? '' : 'running'"
        ></div>
      </div>
      <ng-container *ngIf="progress === 'Supplemented'">
        <div class="ticket-progress-step active">
          <div class="ticket-step-icon">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 5.5H14.5C15.6 5.5 16.5 6.4 16.5 7.5V18.5H6C4.9 18.5 4 17.6 4 16.5V7.5C4 6.4 4.9 5.5 6 5.5Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linejoin="round"
              ></path>
              <path
                class="ticket-write"
                d="M13.5 15.5L18.8 10.2C19.4 9.6 20.4 9.6 21 10.2C21.6 10.8 21.6 11.8 21 12.4L15.7 17.7L13 18.3L13.5 15.5Z"
                fill="currentColor"
              ></path>
              <path
                d="M7.5 9H13"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              ></path>
              <path
                d="M7.5 12.5H11"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              ></path>
            </svg>
          </div>
          <div class="ticket-step-name">已补充</div>
        </div>
        <div class="ticket-progress-segment">
          <div class="ticket-progress-fill"></div>
        </div>
      </ng-container>
      <div
        class="ticket-progress-step"
        [ngClass]="
          progress === 'ProcessCompleted' || progress === 'Completed'
            ? 'done'
            : ''
        "
      >
        <div class="ticket-step-icon">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              class="ticket-check"
              d="M6 12.2L10.1 16.2L18 8"
              stroke="currentColor"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
        <div class="ticket-step-name">已完成</div>
      </div>
    </div>

    <div class="ticket-progress-desc">
      <ng-container *ngIf="progress === 'Supplemented'">
        您已补充相关信息，客服将根据补充内容继续处理。
      </ng-container>
      <ng-container *ngIf="progress === 'Processing'">
        您的工单正在处理中，请耐心等待客服处理。
      </ng-container>
      <ng-container
        *ngIf="progress === 'Completed' || progress === 'ProcessCompleted'"
      >
        您的工单已处理完成，请前往「订阅」界面刷新页面，查看并使用最新账号登录。
      </ng-container>
    </div>
  </div>
</div>
